import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AuthorSideBar from "../../components/Layout/AuthorSideBar";
import OtpModel from "../../components/Model/OtpModel";
import RegisterValidation from "../../yup/Auth/RegisterValidation";
import Button from "../../components/Ui/Button";
import { UserRegisterAction } from "../../redux/Action/AuthAction";
import { VerifyMailType } from "../../constants/Constants";
import $ from "jquery";
import { GetProfileAction } from "../../redux/Action/ProfileAction";
import { Config } from "../../config/Config";
import {
  capitalizeData,
  getFromStorage,
  logoutHelper,
} from "../../utils/Helper";
import { ImageContainer } from "../../constants/ImagesConstants";
import Errormessages from "../../components/ErrorMessage/Errormessages";
import CommanForm from "../../components/FormController/Commanform";
import { FormattedMessage } from "react-intl";

import { useIntl } from "react-intl";
import LanguageSwitcher from "../../components/Layout/LanguageSwitcher";

const Register = () => {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const userRegister = useSelector((state: any) => state.UserRegisterState);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPasword] = useState(false);
  const [onModelClose, setOnModelClose] = useState(false);
  const [data, setData]: any = useState(null);
  const sendOtpButton: any = useRef(null);

  const { register, watch, setValue, errors, handleSubmit, reset, trigger } =
    CommanForm({
      validationSchema: RegisterValidation,
      defaultValues: {
        salon_name: "",
        email: "",
        password: "",
        confirm_password: "",
        phone_number: "",
        agree: false,
      },
    });

  /* ================== Handle form submission start ==================  */
  const onSubmit = (payload: any) => {
    const data = {
      ...payload,
      phone_country_code: `+${payload.phone_country_code}`,
    };

    setOnModelClose(false);
    dispatch(UserRegisterAction(data));

    $(".btnClose").click(() => {
      reset(); // reset data when model box is closed
      dispatch(UserRegisterAction("RESET"));
    });
  };
  /* ================== Handle form submission end ==================  */

  const handleMobileNumber = (value: any, code: any) => {
    const regex = new RegExp(code?.dialCode); // handle phone number
    const phone = value.replace(regex, "");
    setValue("phone_country_code", code?.dialCode);
    setValue("phone_number", phone);
    trigger("phone_number");
  };

  useEffect(() => {
    if (userRegister?.status) {
      const payload = {
        email: userRegister?.data?.custom_params?.email,
        type: VerifyMailType?.MailVerify,
        setOnModelClose,
      };
      setData(payload);
      if (sendOtpButton.current) {
        sendOtpButton.current.click();
      }
    }
  }, [userRegister]);

  useEffect(() => {
    return () => {
      dispatch(UserRegisterAction("RESET"));
      $(".modal-backdrop").remove();
    };
  }, []);

  useEffect(() => {
    if (Config?.IS_USER_LOGIN_TOKEN) {
      dispatch(GetProfileAction({}));
    }
  }, []);

  const navigate = useNavigate();

  const profileData = useSelector((state: any) => state.GetProfileState);

  useEffect(() => {
    if (profileData?.data?.data?.is_profile_setup == 0) {
      logoutHelper();
      // deleteFromStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN })
      // deleteFromStorage({ key: StorageConstants?.USER_DETAIL })
    }
  }, [profileData]);

  useEffect(() => {
    if (Config?.IS_USER_LOGIN_TOKEN) {
      dispatch(GetProfileAction({}));
    }
  }, [userRegister]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserSession = async () => {
      const userSession = await getFromStorage({ key: "isUserLoginToken" });

      if (
        Config?.USER_DETAILS?.is_profile_setup === 1 &&
        userSession !== "" &&
        Config?.USER_DETAILS?.role_id == 1
      ) {
        navigate("/profile-detail");
      } else if (
        Config?.USER_DETAILS?.is_profile_setup === 2 &&
        userSession !== "" &&
        Config?.USER_DETAILS?.role_id == 1
      ) {
        navigate("/");
      } else if (Config?.USER_DETAILS?.role_id == 2) {
        navigate("/dashboard");
      }
      setIsLoading(false);
    };

    checkUserSession();
  }, [navigate]);

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      <div className="container-fluid p-0">
        <div className="row g-0">
          <div className="col-lg-4 d-none d-lg-block">
            <AuthorSideBar />
          </div>
          <div className="col-lg-8">
            <div className="loginRIght">
              <div className="loginTOp text-center text-md-end py-4 d-flex justify-content-between align-items-center px-3 px-md-0">
                <LanguageSwitcher className="d-lg-none" variant="dark" />
                <img alt="logo" src={ImageContainer?.Logo} className="ms-auto" />
              </div>
              <h1>
                <FormattedMessage id="register" />
              </h1>
              <p>
                <FormattedMessage id="create_your_account" />
              </p>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row gy-4 mt-5">
                  <div className="col-lg-6">
                    <div className="inputIcon">
                      <label className="form-label">
                        <FormattedMessage id="salon_name" />*
                      </label>
                      <input
                        type="name"
                        className="form-control"
                        placeholder={intl.formatMessage({ id: "enter_name" })}
                        {...register("salon_name")}
                        value={capitalizeData(watch("salon_name"))}
                      />
                      <span className="iconLeft icon-kechi"></span>
                      <Errormessages name="salon_name" errors={errors} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="inputIcon">
                      <label className="form-label">Email*</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder={intl.formatMessage({
                          id: "enter_email_address",
                        })}
                        {...register("email")}
                      />
                      <span className="iconLeft icon-email"></span>
                      <Errormessages name="email" errors={errors} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="ReactinputIcon">
                      <label className="f-label main-gray-bg">
                        <FormattedMessage id="phone" />*
                      </label>
                      <PhoneInput
                        inputClass="f-input w-100"
                        placeholder=""
                        disableInitialCountryGuess={false}
                        enableLongNumbers={false}
                        country={"us"}
                        countryCodeEditable={false}
                        value={`${watch("phone_country_code")}${watch("phone_number")}`}
                        onChange={handleMobileNumber}
                      />
                      <span className="iconLeft icon-call"></span>
                      <Errormessages name="phone_number" errors={errors} />
                    </div>
                  </div>
                </div>
                <div className="row gy-4 mt-1">
                  <div className="col-md-6">
                    <div className="inputIcon">
                      <label className="form-label">
                        <FormattedMessage id="password" />*
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder={intl.formatMessage({
                          id: "enter_password",
                        })}
                        {...register("password")}
                      />
                      <span className="iconLeft icon-lock"></span>
                      <span
                        className="iconRight viewPassword"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <img alt="hide" src={ImageContainer?.EyeView} />
                        ) : (
                          <img alt="view" src={ImageContainer?.EyeImage} />
                        )}
                      </span>
                      <Errormessages name="password" errors={errors} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="inputIcon">
                      <label className="form-label">
                        <FormattedMessage id="confirm_password" />*
                      </label>
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        placeholder={intl.formatMessage({
                          id: "enter_confirm_password",
                        })}
                        {...register("confirm_password")}
                      />
                      <span className="iconLeft icon-lock"></span>
                      <span
                        className="iconRight viewPassword"
                        onClick={() =>
                          setShowConfirmPasword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <img alt="hide" src={ImageContainer?.EyeView} />
                        ) : (
                          <img alt="view" src={ImageContainer?.EyeImage} />
                        )}
                      </span>
                      <Errormessages name="confirm_password" errors={errors} />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-check rememberMe">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        {...register("agree")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        <FormattedMessage id="accept" />
                        <Link
                          className="fw-600 color-p text-decoration-none"
                          to="/terms-and-conditions"
                        >
                          &nbsp;
                          <FormattedMessage id="terms_conditions" />{" "}
                        </Link>
                        <span>
                          <FormattedMessage id="and" />
                        </span>
                        <Link
                          className="fw-600 color-p  text-decoration-none"
                          to="/privacy-policy"
                        >
                          &nbsp;
                          <FormattedMessage id="privacy_policy." />
                        </Link>
                      </label>
                      <Errormessages name="agree" errors={errors} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <Button
                      type="submit"
                      text={(<FormattedMessage id="sign_up" />) as any}
                      className="btn btn-fill w-100 my-4"
                      isLoading={userRegister?.loading}
                    />
                    <button
                      type="button"
                      style={{ display: "none" }}
                      data-bs-toggle="modal"
                      data-bs-target="#OTPVerify"
                      className="btn btn-fill w-100 my-4"
                      ref={sendOtpButton}
                    >
                      Sign Up
                    </button>
                  </div>
                </div>
                <p className="notAccount">
                  <FormattedMessage id="already_have_an_account?" />
                  <Link className="fw-600 color-p" to="/login">
                    {" "}
                    <FormattedMessage id="login" />{" "}
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
      <OtpModel payload={data} />
    </>
  );
};

export default Register;
